import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// Data
import data from "layouts/dashboard/components/Projects/data";
import PropTypes from "prop-types";

function Projects({ topRestaurantData }) {
  const { columns, rows } = data({ topRestaurantData });
  const [menu, setMenu] = useState(null);

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            My Restaurants
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
}
Projects.propTypes = {
  topRestaurantData: PropTypes.any,
};

export default Projects;
